import ApiMsProjectsService from '@/services/ms_projects_service'
import BaseService from "../../services/base_service"

const deliveryRequestsService = new BaseService(
  process.env.VUE_APP_MS_DELIVERY_REQUESTS_URL,
  process.env.VUE_APP_MS_DELIVERY_REQUESTS_API_KEY
)

const fluxLegalService = new BaseService(
  process.env.VUE_APP_MS_FLUXLEGAL_URL,
  process.env.VUE_APP_MS_FLUXLEGAL_API_KEY,
  'Authorization'
)

export const state = {
  presales: {
    items: [],
    total_items: 0,
    total_pages: 1,
  },
  presale: null,
  typeSales: [],
  contractWebdoxDocument: null,
}

export const getters = {
  presales: (state) => state.presales,
  presale: (state) => state.presale,
  typeSales: (state) => state.typeSales,
  contractWebdoxDocument: (state) => state.contractWebdoxDocument,
}

export const mutations = {
  SET_PRESALES(state, payload) {
    state.presales = {
      items: payload.preventas,
      total_items: payload.total,
      total_pages: payload.number_of_pages,
    }
  },
  SET_PRESALE(state, payload) {
    state.presale = Array.isArray(payload) ? {
      business_unit: payload[0]
    } : {
      business_unit: payload
    }
  }, 
  SET_TYPE_SALES(state, payload){
    state.typeSales = payload
  },
  SET_CONTRACT_WEBDOX_DOCUMENT(state, payload){
    state.contractWebdoxDocument = payload
  },
}

export const actions = {
  async verifyExistClient({_}, payload = {}) {
    try {
      const resp = (await deliveryRequestsService.get(`/api/client_creation/all_clients`, payload)).data
      return resp
    } catch (error) {
      return error
    }
  },
  async updateOrCreateClient({_}, payload){
    let resp = null
    try {
       if(payload.id){
        resp = (await deliveryRequestsService.put(
          `/api/client_creation/update_client`, payload))
        
       }else {
          resp = (await deliveryRequestsService.post(
           `/api/client_creation/create_client`, payload))
       }
      return resp
    } catch (error) {
      return error.response
    }
  },
  async getAllPresales({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(`/preventas/preventas`, payload, payload.export ? 'blob' : undefined)).data
      if(payload.not_update_list){
        return resp
      }
      commit('SET_PRESALES', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async showPresale({ commit }, payload) {
    try {
      const resp = (await ApiMsProjectsService.get(`/documents/project_business_units`, payload)).data
      commit('SET_PRESALE', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateOrCreatePresale({_}, payload){
    let resp = null
    try {
       if(payload.id){
        resp = (await ApiMsProjectsService.put(
          `/preventas/preventas`, payload))
        
       }else {
          resp = (await ApiMsProjectsService.post(
           `/preventas/preventas`, payload))
       }
      return resp
    } catch (error) {
      return error.response
    }
  },
  async updateTypeSalePresale({_}, payload){
    let resp = null
    try {
      resp = (await ApiMsProjectsService.put(
        `/preventas/change_sale_code?preventa_id=${payload.preventa_id}&sale_code=${payload.sale_code}&user=${payload.user}`, payload
      ))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async deletePresale({_}, payload){
    let resp = null
    let queryParamsFormatted = new URLSearchParams(payload).toString()
    try {
       resp = (await ApiMsProjectsService.delete(
          `/preventas/preventas/${payload.preventa_id}?${queryParamsFormatted}`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async linkPresaleToProject({_}, payload){
    let resp = null
    try {
       resp = (await ApiMsProjectsService.get(
          `/documents/transfer_pre_project_to_project?project_code=${payload.project_code}&pre_project_code=${payload.pre_project_code}&user=${payload.user}`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async undoLinkProjectWithPresale({_}, payload){
    let resp = null
    try {
       resp = (await ApiMsProjectsService.put(
          `/documents/undo_transfer_pre_project_to_project?project_code=${payload.project_code}`, payload))
          return resp   
      }
      catch (error) {
        return error
      }
  },
  async getTypeSales({ commit }, payload = {}) {
    try {
      const resp = (await ApiMsProjectsService.get(
        `/preventas/available_sale_types?preventa_id=${payload.preventa_id}`
      )).data
      commit('SET_TYPE_SALES', resp)
      return resp
    }   
    catch (error) {
      return error
    }
  },
  async getSellOrderFromPresale({_}, payload){
    let resp = null
    let queryParamsFormatted = new URLSearchParams(payload).toString()
    try {
       resp = (await ApiMsProjectsService.get(
          `/ov/sell_order?${queryParamsFormatted}`))
      return resp
    }   
    catch (error) {
      return error
    }
  },
  async updateOrCreateProjectFromPresale({_}, payload){
    let resp = null
    let queryParamsFormatted = new URLSearchParams(payload).toString()
    try {
       if(payload.id){
        resp = (await ApiMsProjectsService.put(
          `/ov/sell_order?id=${payload.id}`, payload))
        
       }else {
          resp = (await ApiMsProjectsService.post(
           `/ov/sell_order?${queryParamsFormatted}`, payload))
       }
      return resp
    } catch (error) {
      return error.response
    }
  },
  async updateStatusPresale({_}, payload){
    let resp = null
    let queryParamsFormatted = new URLSearchParams(payload).toString()
    try {
       resp = (await ApiMsProjectsService.post(
          `/ov/approve_preventa?${queryParamsFormatted}`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async undoLinkProjectWithPresalePlatform({_}, payload){
    let resp = null
    try {
       resp = (await ApiMsProjectsService.delete(
          `/preventas/delete_project_from_preventa?preventa_id=${payload.preventa_id}&user=${payload.user}`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async validateDocumentsPresale({_}, payload = {}) {
    try {
      const resp = (await fluxLegalService.post(
        `/api/validate_document_information`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async sendWebdoxDocuments({commit}, payload = {}) {
    try {
      const resp = (await fluxLegalService.post(
        `/api/webdox_document`, payload))
      return resp
    } catch (error) {
      return error.response
    }
  },
  async getWebdoxDocuments({commit}, payload = {}) {
    try {
      const resp = (await fluxLegalService.get(
        `/api/webdox_documents`, payload))
      commit('SET_CONTRACT_WEBDOX_DOCUMENT', resp.data)
      return resp
    } catch (error) {
      return error.response
    }
  },
}